import React from "react";
import PointsCalculator from "./components/PointsCalculator";
import "./App.css";

const App: React.FC = () => {
  return (
    <div className="App">
      <PointsCalculator />
    </div>
  );
};

export default App;
